import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TechGridBackground from "./TechGridBackgroundLazy";
import { seoMetaFor } from "../../data/seoMeta";

const TechGridFloor = () => {
  const { t, i18n } = useTranslation();
  // El H1 de la home vive con el resto de H1 en src/data/seoMeta.js.
  const lang = (i18n.language || "es").startsWith("en") ? "en" : "es";
  const heading = seoMetaFor("/", lang).h1 || t("home_techgrid_title");

  return (
    <section
      className="tech-grid-area"
      style={{ position: "relative", overflow: "hidden", minHeight: "720px" }}
    >
      <TechGridBackground />

      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-7 col-lg-7">
            <div className="tech-grid__content">
              <span className="tech-grid__kicker">{t("home_techgrid_kicker")}</span>
              <h1 className="tech-grid__title">
                {heading}
              </h1>
              <p className="tech-grid__text">
                {t("home_techgrid_text")}
              </p>
              <div className="tech-grid__chips">
                <span className="tech-grid__chip">{t("home_techgrid_chip_one")}</span>
                <span className="tech-grid__chip">{t("home_techgrid_chip_two")}</span>
                {/* Sin precio en la portada (2026-11-04, pedido del owner): la pastilla «Desde 149 €/mes» fuera. */}
              </div>
            </div>
          </div>
          <div className="col-xl-5 col-lg-5">
            {/* El mecanismo, no las specs: este panel desarrolla el kicker
                (Suscribete. Activa. Vende IA.) para quien no ha usado un SaaS.
                Antes habia metricas de red que hablaban a un perfil tecnico,
                que no es el ICP. */}
            <div className="tech-grid__panel">
              <ol className="tech-grid__steps">
                {[1, 2, 3].map((n) => (
                  <li className="tech-grid__step" key={`step-${n}`}>
                    <span className="tech-grid__step-num">{n}</span>
                    <span className="tech-grid__step-body">
                      <strong>{t(`home_techgrid_step_${n}_title`)}</strong>
                      <span>{t(`home_techgrid_step_${n}_text`)}</span>
                    </span>
                  </li>
                ))}
              </ol>
              <div className="tech-grid__actions">
                <Link to="/demo" className="z-btn z-btn-3">
                  {t("demo_cta")}
                </Link>
                <Link to="/get-started" className="tech-grid__btn-ghost">
                  {t("gs_page_title")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechGridFloor;
